import { setLocale } from "react-redux-i18n";

export const setLanguage = languageCode => dispatch => {
  dispatch(setLocale(languageCode));
};